<template>
  <!-- 登录弹窗 -->
  <div class="tip">
    <div class="tip-content" :class="ico">
      <div class="tip-title">提示</div>
      <div class="tip-text">{{text}}</div>
      <div class="btns" v-if="showBtns">
        <button class="button cancel" @click="cancelBtn" v-if="cancelBtnText!='1'">{{cancelBtnText}}</button>
        <button class="button blue" @click="confirmBtn">{{confirmBtnText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: 'tipModal',
  props: {
    text: String,
    showBtns: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Number,
      default: 2000
    },
    ico: {
      type: String,
      default: 'fail'
    },
    fun: Function,
    confirmFun: Function,
    cancelFun: Function,
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    }
  },
  mounted(){
    if(!this.showBtns){
      let _this = this;
      setTimeout(() => {
        _this.CloseTipModal();
        if(_this.fun){
          _this.fun();
        }
      }, _this.showTime);
    }
  },
  methods: {
    ...mapMutations(['CloseTipModal']), //tip弹窗
    //取消按钮
    cancelBtn(){
      this.cancelFun ? this.cancelFun() : this.CloseTipModal();
    },
    confirmBtn(){
      this.confirmFun ? this.confirmFun() : this.CloseTipModal();
    }
  }
}
</script>

<style scoped lang="scss">
.tip{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .tip-content{
    width: 300px;
    background-color: #fff;
    padding: 30px;
    border-radius: 10px;
  }
  .tip-title{
    font-size: 20px;
    color: #333;
  }
  .tip-text{
    padding-top: 20px;
    font-size: 14px;
    text-align: center;
  }
  .btns{
    padding-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
